import NProgress from 'nprogress';
import { ComponentType, lazy } from 'react';
import { captureException } from '~/hooks/useExceptionLogger';

const storageKey = 'lazyImport-force-reload';

NProgress.configure({
  speed: 500,
  showSpinner: false,
});

const lazyImport = <P extends object>(factory: () => Promise<{ default: ComponentType<P> }>) =>
  lazy(async () => {
    try {
      NProgress.start();
      const component = await factory();
      window.sessionStorage.removeItem(storageKey);
      NProgress.done();
      return component;
    } catch (e) {
      captureException(e, {
        extra: {
          storage_key: storageKey,
          factory: factory.toString(),
          help_text: 'trying to get cached component',
        },
      });

      if (!window.sessionStorage.getItem(storageKey)) {
        try {
          window.sessionStorage.setItem(storageKey, 'true');
          console.error(`failed to load ${factory.toString()}, reloading`);
          window.location.reload();
        } catch (err) {
          captureException(err, {
            extra: {
              storage_key: storageKey,
              factory: factory.toString(),
            },
          });
          console.error('failed to set sessionstorage');
          return {
            default: () => (
              <>
                <h1>Error occurred</h1>
                <button onClick={() => window.location.reload()}>Reload</button>
              </>
            ),
          };
        }
        return { default: () => <></> };
      }

      return {
        default: () => (
          <>
            <h1>Error occurred</h1>
            <button onClick={() => window.location.reload()}>Reload</button>
          </>
        ),
      };
    }
  });

export default lazyImport;
